import React from 'react';

import { DEFAULT_PRO_SECTIONS } from '../constants';

import { ProSection, ProSectionProps } from './ProSection';

interface IProps {
  partnerFlow?: boolean;
  proSectionsData?: ProSectionProps[];
}

export const ProSections = ({ partnerFlow, proSectionsData }: IProps) => {
  const proSections = proSectionsData || DEFAULT_PRO_SECTIONS;

  return (
    <div className="w-full bg-lake-fog">
      {proSections.map(({ title, ...rest }) => (
        <ProSection key={title} partnerFlow={partnerFlow} {...rest} title={title} />
      ))}
    </div>
  );
};
